import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const QRScannerContainer = styled.div({
  display: 'flex',
  flex: 1,
  width: '100%',
  height: '100%',
  flexDirection: 'column',
  '*':{
    fontSize: '1.2rem !important',
  }
})

export const HeaderContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  justifyContent: 'space-between',
  minHeight: '60px',
  background: v.ezMainColor,
  padding: '0px 10px',

  'div.applicationName': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: '#FFF',

    'h6':{
      fontWeight:'bold'
    }
  },
})

export const QRScannerBody = styled.div({
  display: 'flex',
  width: '100%',
  height: '100%',
  background: v.ezGrayColor,
  padding: '20px',
  flexDirection: 'column',
  alignItems:'center',

  '.rightContent': {
    display: 'flex',
    paddingLeft: '10px',
    flexDirection: 'column',
    paddingRight: '10px',
    width:'50%',
    "@media (max-width: 1200px)": {
      width:'100%'
    },
  },

  'span.title': {
    fontWeight: 'bold',
    marginBottom: '10px',
  }
})

export const DocumentDataSection = styled.div({
  display: 'flex',
  padding: '10px',
  borderRadius: '5px',
  width: '100%',
  background: v.bgSoftGray,
  marginBottom: '10px',
  flexDirection: 'column',

  'span.sectionTitle': {
    marginBottom: '5px',
    fontWeight: 'bold',
  },

  'div.row': {
    display: 'flex',
    flexDirection: 'row',
    gap:'1rem',

    'div.title': {
      fontWeight: 'bold',
      wordBreak:'keep-all',
    },

    'div.value': {
      flex: 1,
    },
  }
})

export const ButtonSection = styled.div({
  display: 'flex',
  alignSelf:'flex-end',
  justifyContent:'center',
  gap:'1rem',

  '.invalidMessage':{
    color:'red',
    alignSelf:'center',
  },

  'button':{
    alignSelf:'center'
  }

})